import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../actions/ActionCreator";
import * as memberType from "../actions/ActionType";
import { API_ENDPOINT } from "../URLs/ApiEndpoints";
import * as Api from "../../appApi/AppApi";

function* workerCarrierList(payLoad) {
  try {
    const response = yield call(
      Api.makeSecuredPostRequest,
      API_ENDPOINT.CARRIER_LIST,
      {}
    );
    yield put(memberAction.carrierListSuccess(response));
  } catch (error) {
    yield put(memberAction.carrierListFailed(error.message));
  }
}

export const watchCarrierList = takeLatest(
  memberType.CARRIER_LIST_REQUESTED,
  workerCarrierList
);
